<template>
  <div class="panel">
    <h3>Registros de Asistentes (Todos los stands)</h3>
    <button @click="descargar" class="csv-btn">Descargar CSV General</button>
    <div style="margin:12px 0;">
      <label>Filtrar por Stand:</label>
      <select v-model="standFiltro">
        <option value="">Todos</option>
        <option v-for="s in standsUnicos" :key="s">{{ s }}</option>
      </select>
    </div>
    <div class="tabla-contenedor">
      <table>
        <thead>
          <tr>
            <th>Stand</th>
            <th>Nombre</th>
            <th>Teléfono</th>
            <th>Email</th>
            <th>Interés</th>
            <th>Nota</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in asistentesFiltrados" :key="a.id">
            <td>{{ a.stand_name }}</td>
            <td>{{ a.name }}</td>
            <td>{{ a.phone }}</td>
            <td>{{ a.email }}</td>
            <td>{{ a.interest === 'otro' && a.other_interest ? a.other_interest : capitalizar(a.interest) }}</td>
            <td>{{ a.note }}</td>
            <td>{{ a.created_at ? a.created_at.slice(0,10) : '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['token'],
  data() {
    return {
      asistentes: [],
      standFiltro: ''
    }
  },
  computed: {
    asistentesFiltrados() {
      if (!this.standFiltro) return this.asistentes
      return this.asistentes.filter(a => a.stand_name === this.standFiltro)
    },
    standsUnicos() {
      // Array de stands únicos para el filtro
      const unicos = new Set(this.asistentes.map(a => a.stand_name).filter(Boolean))
      return Array.from(unicos)
    }
  },
  methods: {
    capitalizar(s) { if (!s) return ""; return s.charAt(0).toUpperCase() + s.slice(1); },
    async descargar() {
      const res = await axios.get('/api/attendees/export', {
        headers: { Authorization: 'Bearer ' + this.token },
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'asistentes_general.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async cargar() {
      const res = await axios.get('/api/attendees', {
        headers: { Authorization: 'Bearer ' + this.token }
      })
      this.asistentes = res.data
    }
  },
  mounted() {
    this.cargar()
  }
}
</script>

<style scoped>
.csv-btn { background: #1bad58; color: #fff; margin-bottom: 10px; }
.panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px #0001;
  padding: 20px;
  margin-top: 12px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
input, select, textarea, button {
  padding: 7px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.97em;
  margin-bottom: 8px;
}
.tabla-contenedor { overflow-x: auto; margin-top: 20px; }
table { width: 100%; border-collapse: collapse; font-size: 0.97em; }
th, td { padding: 6px 10px; border: 1px solid #eee; text-align: left; }
th { position: sticky; top: 0; background: #f9f9f9; z-index: 2; }
</style>
